import { render, staticRenderFns } from "./password.vue?vue&type=template&id=75676236&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75676236')) {
      api.createRecord('75676236', component.options)
    } else {
      api.reload('75676236', component.options)
    }
    module.hot.accept("./password.vue?vue&type=template&id=75676236&", function () {
      api.rerender('75676236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tax-payer/password.vue"
export default component.exports